module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceMain.dece47d3.jpg";